import React, { createContext, useState, useEffect, useContext } from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';

const BookmarkContext = createContext();

export const BookmarkProvider = ({ children }) => {
  const [bookmarkedCalculators, setBookmarkedCalculators] = useState([]);

  // Load bookmarks from localStorage on mount
  useEffect(() => {
    const savedBookmarks = localStorage.getItem('bookmarkedCalculators');
    if (savedBookmarks) {
      try {
        setBookmarkedCalculators(JSON.parse(savedBookmarks));
      } catch (error) {
        console.error('Error parsing bookmarks:', error);
      }
    }
  }, []);

  // Save bookmarks to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('bookmarkedCalculators', JSON.stringify(bookmarkedCalculators));
  }, [bookmarkedCalculators]);

  // Add or remove calculator from bookmarks
  const toggleBookmark = (calculator) => {
    setBookmarkedCalculators(prev => {
      const isBookmarked = prev.some(item => item.path === calculator.path);
      
      // Track bookmark action
      try {
        const analytics = getAnalytics();
        logEvent(analytics, 'bookmark_calculator', {
          calculator_name: calculator.title,
          calculator_category: calculator.category,
          action: isBookmarked ? 'remove' : 'add'
        });
      } catch (error) {
        console.error('Analytics error:', error);
      }
      
      if (isBookmarked) {
        return prev.filter(item => item.path !== calculator.path);
      } else {
        return [...prev, calculator];
      }
    });
  };

  // Check if calculator is bookmarked
  const isBookmarked = (calculatorPath) => {
    return bookmarkedCalculators.some(item => item.path === calculatorPath);
  };

  return (
    <BookmarkContext.Provider value={{ bookmarkedCalculators, toggleBookmark, isBookmarked }}>
      {children}
    </BookmarkContext.Provider>
  );
};

// Export both versions of the hook for backward compatibility
export const useBookmarks = () => useContext(BookmarkContext);
export const useBookmark = () => useContext(BookmarkContext);
